import { render, staticRenderFns } from "./UsersPasswordReset.vue?vue&type=template&id=4892f5ae"
import script from "./UsersPasswordReset.vue?vue&type=script&lang=js"
export * from "./UsersPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports